// removed by extract-text-webpack-plugin
module.exports = {"body":"Body-style__body__e91c8cba"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/views/modal/Body-style.scss
// module id = 551
// module chunks = 4 5 7 8 10 36